import React from 'react';

import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

import IntlMessage from '../intlMessage/IntlMessage';

export function PopUpButtons({data}) {
  return (
    <>
      {data.map((button) => {
        // eslint-disable-next-line no-nested-ternary
        const classButton = button.isPrimaryButton
          ? `primaryButton no-outline ${button.className}`
          : button.className
          ? `${button.className} no-outline `
          : 'secondaryButton no-outline ';
        return (
          <Button
            id={button.id}
            key={button.id}
            bsSize="large"
            className={classButton}
            onClick={button.onClick}
            disabled={button.disabled}
          >
            <IntlMessage
              id={button.label}
              defaultMessage={button.label}
            />
          </Button>
        );
      })}
    </>
  );
}

PopUpButtons.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      isPrimaryButton: PropTypes.bool,
      className: PropTypes.string,
      id: PropTypes.string,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      label: PropTypes.string,
    }),
  ),
};

PopUpButtons.defaultProps = {
  data: [],
};

export default PopUpButtons;
